"use client"

import { useState } from "react"
import Image from "next/image"

import { SalesIcon } from "./icons"

interface BunnyClickToPlayProps {
  videoId: string
  title: string
  /** aspect-ratio CSS, ex. "16 / 9", "4 / 5". */
  ratio?: string
  posterUrl?: string | null
  playSize?: number
  playTone?: "pink" | "white"
  className?: string
}

/**
 * Poster + play → iframe Bunny sob clique. O embed só entra no DOM depois
 * da interação: a página não paga o custo do player no load.
 */
export function BunnyClickToPlay({
  videoId,
  title,
  ratio = "16 / 9",
  posterUrl,
  playSize = 62,
  playTone = "pink",
  className = "",
}: BunnyClickToPlayProps) {
  const [playing, setPlaying] = useState(false)
  const libraryId = process.env.NEXT_PUBLIC_BUNNY_LIBRARY_ID

  if (!libraryId) return null

  if (playing) {
    return (
      <div
        className={`relative overflow-hidden ${className}`}
        style={{ aspectRatio: ratio }}
      >
        <iframe
          src={`https://iframe.mediadelivery.net/embed/${libraryId}/${videoId}?autoplay=true&preload=true`}
          className="absolute inset-0 h-full w-full border-0"
          title={title}
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
          allowFullScreen
        />
      </div>
    )
  }

  return (
    <button
      type="button"
      onClick={() => setPlaying(true)}
      aria-label={`Assistir: ${title}`}
      className={`group relative block w-full cursor-pointer overflow-hidden bg-[#0c1f27] ${className}`}
      style={{ aspectRatio: ratio }}
    >
      {posterUrl && (
        <Image
          src={posterUrl}
          alt=""
          fill
          sizes="(max-width: 1024px) 100vw, 560px"
          className="object-cover"
        />
      )}
      <span className="absolute inset-0 flex items-center justify-center">
        <span
          className={`flex items-center justify-center rounded-full transition-transform group-hover:scale-105 group-active:scale-95 ${
            playTone === "pink"
              ? "bg-primary-600 shadow-[0_14px_40px_-10px_rgba(198,6,131,.8)]"
              : "bg-white/95"
          }`}
          style={{ width: playSize, height: playSize }}
        >
          <SalesIcon.play
            width={playSize * 0.32}
            height={playSize * 0.32}
            className={
              playTone === "pink"
                ? "ml-[3px] text-white"
                : "ml-[2px] text-sales-ink"
            }
          />
        </span>
      </span>
    </button>
  )
}
